module.exports = __webpack_public_path__ + "static/media/PC_Data.8b414a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Intel_em_Cybersecurity/PC_Data.png
// module id = 65
// module chunks = 0